import { Box, Card, Divider } from '@mui/material';
import ChevronRightTwoToneIcon from '@mui/icons-material/ChevronRightTwoTone';
import { ButtonWrapper } from './ButtonWrapper';
import { useHistory } from 'react-router-dom';
import { t } from 'i18next';

export const DataProductsBlock = () => {
  const history = useHistory();

  const handleButtonClick = async (): Promise<void> => {
    history.push('data-products');
  };

  return (
    <Card>
      <Box display='flex' alignItems='center' p={2}></Box>
      <Divider />
      <ButtonWrapper fullWidth endIcon={<ChevronRightTwoToneIcon />} onClick={handleButtonClick}>
        {t('dataProducts')}
      </ButtonWrapper>
    </Card>
  );
};
